import { IconName } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useState } from 'react'

interface Props {
  list: {
    icon: IconName
    text: string
    callback: VoidFunction
  }[]
}

const GroupButton: FC<Props> = (props) => {
  const {
    list,
  } = props

  const [isOpenList, setIsOpenList] = useState<boolean>(false)

  const detailClick = (callback: VoidFunction) => {
    setIsOpenList(false)
    callback()
  }

  return (
    <>
      {
        list.length === 0 && (
          <></>
        )
      }
      {
        list.length === 1 && (
          <>
            <button
              type="button"
              className="button"
              onClick={() => detailClick(list[0].callback)}
            >
              {list[0].text}
            </button>
          </>
        )
      }
      {
        list.length > 1 && (
          <>
            <div className="group_button">
              <button
                type="button"
                className="main_contents"
                onClick={() => detailClick(list[0].callback)}
              >
                <FontAwesomeIcon icon={['fas', list[0].icon]} />
                {list[0].text}
              </button>
              <div className="separator" />
              <button
                type="button"
                onClick={() => setIsOpenList(true)}
              >
                <FontAwesomeIcon icon={['fas', 'caret-down']} />
              </button>
            </div>
            {
              isOpenList && (
                <>
                  <div className="group_list">
                    {
                      list.map((v) => (
                        <button
                          type="button"
                          onClick={() => detailClick(v.callback)}
                        >
                          <FontAwesomeIcon icon={['fas', v.icon]} />
                          {v.text}
                        </button>
                      ))
                    }
                  </div>
                  <div className="close_screen gray" role="presentation" onClick={() => setIsOpenList(false)} />
                </>
              )
            }
          </>
        )
      }
    </>
  )
}

export default GroupButton
